import { jsx as _jsx } from "react/jsx-runtime";
import { Ribbon } from '../../elementals';
export const ListingInfoCardRibbon = ({ listing, statusLabelRole, }) => {
    const { color, icon } = statusLabelRole;
    if (!listing?.listing_status_label || !statusLabelRole.color)
        return null;
    return (_jsx(Ribbon, { color: color, size: 'large', style: {
            zIndex: 2,
        }, "data-elm-id": 'ribbon', children: _jsx(Ribbon.Content, { title: listing.listing_status_label, iconProps: {
                name: icon,
                color: 'white',
            } }) }));
};
//# sourceMappingURL=listingInfoCardRibbon.js.map